import type { Space } from '@cocoonspace/sdk-js/types/space'
import type { SpaceHours } from '@cocoonspace/sdk-js/types/spaceHours'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { useMemo } from 'react'

export interface OpeningHour {
	dayStart: string
	dayEnd: string
	open?: { from: string; to: string }[]
	closed?: boolean
}

const getConcatDaysHours = (hours?: SpaceHours) => {
	if (!hours) return []

	const { bank_holidays, ...days } = hours

	let currentStartEnd = {}
	const openingHours: OpeningHour[] = []

	Object.entries(days).forEach(([day, row]) => {
		if (currentStartEnd === JSON.stringify(row)) {
			openingHours[openingHours.length - 1].dayEnd = day
		} else {
			currentStartEnd = JSON.stringify(row)

			const { closed, open } = row

			openingHours.push({
				dayStart: day,
				dayEnd: '',
				closed,
				open: open?.map((time) => ({
					from: dateTimeUtils.utils
						.parseTime(time.from || '')
						.customFormat('hours'),
					to: dateTimeUtils.utils
						.parseTime(time.to || '')
						.customFormat('hours'),
				})) as OpeningHour['open'],
			})
		}
	})

	return openingHours
}

export const useSpaceHours = (hours?: Space['hours']) => {
	const spaceHours = useMemo(() => getConcatDaysHours(hours), [hours])

	return {
		spaceHours,
	}
}
